<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="wan1InterfaceLoading || firmwareAndModelAuditLoading">
    <button mat-raised-button color="primary" id="store-number-search-button" (click)="getSiteAudit()">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput maxlength="5" minLength="5" [(ngModel)]="storeNumber" autofocus
        (keydown.enter)="getSiteAudit()"/>
    </mat-form-field>
  </div>
  <div class="quick-navigation-buttons">
    @if (storeNumber != '') {
      <button mat-raised-button [routerLink]="['/health/device']" [queryParams]="{storeNumber:storeNumber}"
        color="secondary" id="quick-navigate-wan-health-button">
        <span>Device Health</span>
      </button>
    }
  </div>
</div>
<div class="card-wrapper">
  @if (wan1Interface != null) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>WAN 1 Interface</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-divider></mat-divider>
        <p><b>Description:</b> {{wan1Interface.description}}</p>
        <p><b>Status:</b> {{wan1Interface.status}}</p>
        <p><b>Bandwidth In:</b> {{wan1Interface.provisioned_bandwidth_in}}</p>
        <p><b>Bandwidth Out:</b> {{wan1Interface.provisioned_bandwidth_out}}</p>
        <p><b>Default Gateway:</b> {{wan1Interface.default_gw}}</p>
        <p><b>IP:</b> {{wan1Interface.ip}}</p>
        <p><b>Mode:</b> {{wan1Interface.mode}}</p>
        <p><b>Distance:</b> {{wan1Interface.distance}}</p>
        <p><b>Speed:</b> {{wan1Interface.speed}}</p>
      </mat-card-content>
    </mat-card>
  }
</div>
<div class="main-card-wrapper">
  <div class="table-wrapper">
    <h2>Device Firmware Audit</h2>
    <table mat-table matSort #firmwareAuditTable [dataSource]="firmwareDataSource" class="audit-table mat-elevation-z8">
      <ng-container matColumnDef="device">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Device </th>
        <td mat-cell *matCellDef="let restaurant">
          {{restaurant.device}}
        </td>
      </ng-container>
      <ng-container matColumnDef="recommendation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Recommendation </th>
        <td mat-cell *matCellDef="let restaurant">
          {{restaurant.reason}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="firmwareDisplayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: firmwareDisplayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
  <div class="table-wrapper">
    <h2>Device Model Audit</h2>
    <table mat-table matSort #modelAuditTable [dataSource]="modelDataSource" class="audit-table mat-elevation-z8">
      <ng-container matColumnDef="device">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Device </th>
        <td mat-cell *matCellDef="let restaurant">
          {{restaurant.device}}
        </td>
      </ng-container>
      <ng-container matColumnDef="recommendation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Recommendation </th>
        <td mat-cell *matCellDef="let restaurant">
          {{restaurant.reason}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="modelDisplayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: modelDisplayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>